import { useState, useEffect } from 'react';
import userInfo from 'hub-http/userInfo';
import { reportErrorToRaven } from '../utils/errors';
const useUserInfo = () => {
  const [userInfoData, setUserInfoData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  useEffect(() => {
    setIsLoading(true);
    userInfo().then(auth => {
      setUserInfoData(auth);
      setIsLoading(false);
    }).catch(fetchError => {
      setError(fetchError);
      setIsLoading(false);
      reportErrorToRaven(fetchError, 'Auth state fetch failed in useUserInfo hook');
    });
  }, []);
  return {
    userInfo: userInfoData,
    isLoading,
    error
  };
};
export const usePortalIsUngated = gate => {
  const {
    userInfo: userInfoData,
    isLoading,
    error
  } = useUserInfo();
  if (isLoading) {
    return null;
  }
  if (error || !userInfoData) {
    return false;
  }
  return userInfoData.gates.includes(gate);
};
export default useUserInfo;